<script setup lang="ts">
import CSInputText from '@/onenetwork/components/form/CSInputText.vue';
import LoginLayout from '@/onenetwork/layouts/LoginLayout.vue';
import { useAuthStore } from '@/onenetwork/stores/onenetwork.store.auth.ts';
import { Icon } from '@iconify/vue';
import { yupResolver } from '@primevue/forms/resolvers/yup';
import { useToast } from 'primevue/usetoast';
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as yup from 'yup';

const authStore = useAuthStore()

const toast = useToast();
const initialValues = ref({
  otp: '',
  phone_number: '',
});

const router = useRouter()
const route = useRoute();
const formRef = ref<any>(null);

const schemaYup = yup.object().shape({
  otp: yup.string().required('Mã xác thực không được để trống').min(6, 'Mã xác thực phải có 6 chữ số'),
});

const resolver = yupResolver(schemaYup);

const loading = ref(false)

const onFormSubmit = ({values, valid}: any) => {
  console.log(route.query.phone_number, values.otp, 'xxxx')
  if(!valid) return;
  try{
    loading.value = true
    authStore.verifyOTP(route.query.phone_number as string, values.otp)
    .then((res: any) => {
      console.log(res, 'xxxx')
      toast.add({ severity: 'success', summary: 'Mã xác thực thành công', detail: `Mã xác thực thành công, vui lòng thiết lập mật khẩu mới`, life: 2000 });
      setTimeout(() => {
        loading.value = false
        router.push({
          path: '/auth/reset-pw',
          query: {
            phone_number: route.query.phone_number
          }
        });
      }, 1000)
    })
    .catch((e: any) => {
      loading.value = false
      toast.add({ severity: 'error', summary: 'Mã xác thực không chính xác', detail: `Mã xác thực không chính xác, vui lòng thử lại`, life: 2000 });
    })
  } catch (e) {
    loading.value = false
    toast.add({ severity: 'error', summary: 'Mã xác thực không chính xác', detail: `Mã xác thực không chính xác, vui lòng thử lại`, life: 2000 });
  }

};
</script>

<template>
<div class="auth-page flex w-[100vw] h-[100vh] flex-col md:flex-row items-center">
  <LoginLayout />
  <div class="flex flex-1 h-[100vh] p-5 justify-center flex-col px-[16px]">
    <Form v-slot="$form"
          :initial-values="initialValues"
          ref="formRef"
          :resolver="resolver"
          @submit="onFormSubmit" class="w-full md:w-[20vw] mx-auto ">
      <h3 class="font-bold text-xl mb-3">Nhập mã xác thực</h3>
      <div class="flex flex-col mb-3">
        <div class="flex-1 text-[12px] mb-1">Mã xác thực:</div>
        <div class="flex-1">
          <CSInputText
            :model-value="initialValues?.otp"
              name="otp"
              type="text"
              class="form-control"
              maxlength="6"
              @keypress="(e) => {
                const charCode = (e.which) ? e.which : e.keyCode;
                if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                  e.preventDefault();
                }
              }"
              @paste="(e: ClipboardEvent) => {
                e.preventDefault();
                const text = e.clipboardData?.getData('text') || '';
                const numbers = text.replace(/\D/g, '').slice(0, 6);
                formRef.value?.setFieldValue('otp', numbers);
              }"
            />
          <Message v-if="$form.otp?.invalid" severity="error"  variant="simple">{{ $form?.otp?.error?.message }}</Message>
        </div>
      </div>
      <div class="flex justify-between items-center">
        <Button type="submit" class="px-[40px] py-[10px] bg-[#ff6f00] text-white hover:bg-[#1E88E5] cursor-pointer" :disabled="loading">
          Xác thực mã OTP <Icon icon="eos-icons:three-dots-loading" v-if="loading" />
        </Button>
        <div class="!ml-5">
          <router-link to="/auth/forget-pw" class="hover:text-slate-700 text-[12px]">Quay về</router-link>
        </div>
      </div>
    </Form>
    <br/>
    <br/>
    <br/>
  </div>
</div>
</template>

<style scoped>

</style>
